/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createAccessRequest = /* GraphQL */ `
  mutation CreateAccessRequest(
    $condition: ModelAccessRequestConditionInput
    $input: CreateAccessRequestInput!
  ) {
    createAccessRequest(condition: $condition, input: $input) {
      adminNotes
      createdAt
      description
      email
      id
      owner
      status
      updatedAt
      __typename
    }
  }
`;
export const createAgentSchedule = /* GraphQL */ `
  mutation CreateAgentSchedule(
    $condition: ModelAgentScheduleConditionInput
    $input: CreateAgentScheduleInput!
  ) {
    createAgentSchedule(condition: $condition, input: $input) {
      createdAt
      cronExpression
      description
      error
      id
      lastRunAt
      metadata
      nextRunAt
      organizationId
      owner
      projectId
      runCount
      runners {
        nextToken
        __typename
      }
      runs {
        nextToken
        __typename
      }
      runtime
      status
      systemPrompt
      timezone
      title
      updatedAt
      __typename
    }
  }
`;
export const createAgentScheduleRun = /* GraphQL */ `
  mutation CreateAgentScheduleRun(
    $condition: ModelAgentScheduleRunConditionInput
    $input: CreateAgentScheduleRunInput!
  ) {
    createAgentScheduleRun(condition: $condition, input: $input) {
      conversations {
        nextToken
        __typename
      }
      createdAt
      error
      id
      organizationId
      owner
      schedule {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      scheduleId
      status
      updatedAt
      __typename
    }
  }
`;
export const createAgentScheduleRunner = /* GraphQL */ `
  mutation CreateAgentScheduleRunner(
    $condition: ModelAgentScheduleRunnerConditionInput
    $input: CreateAgentScheduleRunnerInput!
  ) {
    createAgentScheduleRunner(condition: $condition, input: $input) {
      attachments
      conversations {
        nextToken
        __typename
      }
      createdAt
      emailCondition
      emailConditionMode
      id
      organizationId
      owner
      prompt
      schedule {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      scheduleId
      sendEmail
      sortOrder
      title
      updatedAt
      __typename
    }
  }
`;
export const createApiIdempotencyKey = /* GraphQL */ `
  mutation CreateApiIdempotencyKey(
    $condition: ModelApiIdempotencyKeyConditionInput
    $input: CreateApiIdempotencyKeyInput!
  ) {
    createApiIdempotencyKey(condition: $condition, input: $input) {
      claimToken
      createdAt
      expiresAt
      id
      owner
      requestHash
      response
      responseStatus
      route
      status
      updatedAt
      __typename
    }
  }
`;
export const createAssetGroup = /* GraphQL */ `
  mutation CreateAssetGroup(
    $condition: ModelAssetGroupConditionInput
    $input: CreateAssetGroupInput!
  ) {
    createAssetGroup(condition: $condition, input: $input) {
      assets {
        nextToken
        __typename
      }
      createdAt
      description
      displayedChannels
      id
      linkedProcessedModelSchemas {
        nextToken
        __typename
      }
      name
      organizationId
      owner
      profilePictureUrl
      updatedAt
      userAssetGroupsId
      __typename
    }
  }
`;
export const createComposedForecast = /* GraphQL */ `
  mutation CreateComposedForecast(
    $condition: ModelComposedForecastConditionInput
    $input: CreateComposedForecastInput!
  ) {
    createComposedForecast(condition: $condition, input: $input) {
      aggregationMethod
      createdAt
      dataSources {
        nextToken
        __typename
      }
      description
      forecastHorizon
      forecastType
      id
      isActive
      lastProcessed
      linkedAssets {
        nextToken
        __typename
      }
      name
      organizationId
      outputParameters
      owner
      processingSchedule
      updateFrequency
      updatedAt
      validationThresholds
      __typename
    }
  }
`;
export const createComposedForecastAssets = /* GraphQL */ `
  mutation CreateComposedForecastAssets(
    $condition: ModelComposedForecastAssetsConditionInput
    $input: CreateComposedForecastAssetsInput!
  ) {
    createComposedForecastAssets(condition: $condition, input: $input) {
      asset {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      assetID
      composedForecast {
        aggregationMethod
        createdAt
        description
        forecastHorizon
        forecastType
        id
        isActive
        lastProcessed
        name
        organizationId
        outputParameters
        owner
        processingSchedule
        updateFrequency
        updatedAt
        validationThresholds
        __typename
      }
      composedForecastID
      createdAt
      icon
      id
      isDefault
      organizationId
      owner
      updatedAt
      __typename
    }
  }
`;
export const createComposedForecastDataSource = /* GraphQL */ `
  mutation CreateComposedForecastDataSource(
    $condition: ModelComposedForecastDataSourceConditionInput
    $input: CreateComposedForecastDataSourceInput!
  ) {
    createComposedForecastDataSource(condition: $condition, input: $input) {
      composedForecast {
        aggregationMethod
        createdAt
        description
        forecastHorizon
        forecastType
        id
        isActive
        lastProcessed
        name
        organizationId
        outputParameters
        owner
        processingSchedule
        updateFrequency
        updatedAt
        validationThresholds
        __typename
      }
      composedForecastId
      createdAt
      dataOperations
      dataQualityScore
      externalApiEndpoint
      externalApiHeaders
      externalApiKey
      externalApiParams
      fallbackStrategy
      fallbackValue
      fetchErrorMessage
      groundTruthSensorId
      groundTruthTableName
      id
      isActive
      lastFetchStatus
      lastFetchedAt
      metadata
      modelOutputTimeOffset
      organizationId
      owner
      postgresAggregation
      postgresColumns
      postgresQuery
      postgresTable
      postgresTimeRange
      priority
      processedModelOutput {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      processedModelOutputId
      projectId
      s3FileFormat
      s3Location
      s3ParseConfig
      sourceDescription
      sourceName
      sourceType
      temporalResolution
      timeAlignment
      timeLag
      transformations
      updatedAt
      validationRules
      weight
      zarrCoordinates
      zarrPath
      zarrTimeSelection
      zarrVariable
      __typename
    }
  }
`;
export const createDataSetRecord = /* GraphQL */ `
  mutation CreateDataSetRecord(
    $condition: ModelDataSetRecordConditionInput
    $input: CreateDataSetRecordInput!
  ) {
    createDataSetRecord(condition: $condition, input: $input) {
      columns
      compressedSize
      compressionType
      createdAt
      dataset {
        columns
        createdAt
        curationMode
        datasetType
        deletedAt
        description
        duplicatePolicy
        fileFormat
        fileSize
        id
        ingestMetadata
        lastUpdated
        linkedAssets
        linkedSchemas
        location
        locationId
        name
        organizationId
        owner
        parameterType
        profilePictureUrl
        recordCount
        routeLong
        slug
        sourceModelId
        tags
        timeRange
        units
        updateFrequency
        updatedAt
        userId
        __typename
      }
      datasetId
      fileName
      fileSize
      id
      organizationId
      owner
      recordCount
      s3Path
      timeRange
      timeValue
      updatedAt
      uploadId
      uploadedAt
      uploadedBy
      uploadedByEmail
      __typename
    }
  }
`;
export const createDataSource = /* GraphQL */ `
  mutation CreateDataSource(
    $condition: ModelDataSourceConditionInput
    $input: CreateDataSourceInput!
  ) {
    createDataSource(condition: $condition, input: $input) {
      createdAt
      dataOperations
      databaseTable
      format
      id
      isGroundTruth
      metadata
      name
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaId
      s3Path
      sourceType
      updatedAt
      __typename
    }
  }
`;
export const createDataset = /* GraphQL */ `
  mutation CreateDataset(
    $condition: ModelDatasetConditionInput
    $input: CreateDatasetInput!
  ) {
    createDataset(condition: $condition, input: $input) {
      columns
      createdAt
      curationMode
      datasetType
      deletedAt
      description
      duplicatePolicy
      fileFormat
      fileSize
      id
      ingestMetadata
      lastUpdated
      linkedAssets
      linkedSchemas
      location
      locationId
      name
      organizationId
      owner
      parameterType
      profilePictureUrl
      recordCount
      records {
        nextToken
        __typename
      }
      routeLong
      slug
      sourceModelId
      tags
      timeRange
      units
      updateFrequency
      updatedAt
      userId
      __typename
    }
  }
`;
export const createDatasetUpload = /* GraphQL */ `
  mutation CreateDatasetUpload(
    $condition: ModelDatasetUploadConditionInput
    $input: CreateDatasetUploadInput!
  ) {
    createDatasetUpload(condition: $condition, input: $input) {
      columnMetadata
      columnSources
      columns
      createdAt
      datasetId
      duplicateTimestamps
      failureReason
      fileName
      id
      incomingKey
      inputsReadAt
      organizationId
      outputParamId
      owner
      processedAt
      processedModelSchemaId
      rawKey
      receivedAt
      recordId
      rejectedKey
      requestedAt
      rowCount
      runId
      sizeBytes
      source
      sourceTimezone
      status
      timeRange
      updatedAt
      uploadedBy
      uploadedByEmail
      validationErrors
      warnings
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const createErrorLog = /* GraphQL */ `
  mutation CreateErrorLog(
    $condition: ModelErrorLogConditionInput
    $input: CreateErrorLogInput!
  ) {
    createErrorLog(condition: $condition, input: $input) {
      adminNotes
      cognitoIdentityId
      createdAt
      description
      id
      images
      mcpConversationId
      mcpMessageId
      owner
      pageUrl
      source
      status
      updatedAt
      userEmail
      __typename
    }
  }
`;
export const createForecastRecord = /* GraphQL */ `
  mutation CreateForecastRecord(
    $condition: ModelForecastRecordConditionInput
    $input: CreateForecastRecordInput!
  ) {
    createForecastRecord(condition: $condition, input: $input) {
      createdAt
      forecastIssued
      id
      inputs
      metadata
      organizationId
      owner
      parameter {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      parameterId
      run {
        acknowledged
        acknowledgedAt
        acknowledgedBy
        attempt
        completedAt
        createdAt
        description
        executionTimeMs
        id
        inputs
        modelSchemaTemplateId
        organizationId
        outputS3Keys
        owner
        processedModelScheduleId
        processedModelSchemaId
        requestId
        startedAt
        status
        triggerType
        updatedAt
        windowEnd
        windowStart
        __typename
      }
      runId
      s3Key
      seriesEnd
      seriesMetaData
      seriesStart
      source
      updatedAt
      uploadId
      uploadedBy
      __typename
    }
  }
`;
export const createForecastReport = /* GraphQL */ `
  mutation CreateForecastReport(
    $condition: ModelForecastReportConditionInput
    $input: CreateForecastReportInput!
  ) {
    createForecastReport(condition: $condition, input: $input) {
      completedAt
      config
      createdAt
      description
      error
      id
      identityId
      name
      organizationId
      owner
      progress
      resultS3Key
      startedAt
      status
      summary
      updatedAt
      __typename
    }
  }
`;
export const createForecastUpload = /* GraphQL */ `
  mutation CreateForecastUpload(
    $condition: ModelForecastUploadConditionInput
    $input: CreateForecastUploadInput!
  ) {
    createForecastUpload(condition: $condition, input: $input) {
      createdAt
      failureReason
      fileName
      finalKey
      forecastIssued
      forecastRecordId
      id
      incomingKey
      issueTime
      organizationId
      outputParamId
      owner
      parameters
      processedAt
      rawKey
      receivedAt
      requestedAt
      rowCount
      schemaId
      sizeBytes
      source
      status
      timeRange
      updatedAt
      uploadedBy
      uploadedByEmail
      validationErrors
      warnings
      __typename
    }
  }
`;
export const createGeoPoint = /* GraphQL */ `
  mutation CreateGeoPoint(
    $condition: ModelGeoPointConditionInput
    $input: CreateGeoPointInput!
  ) {
    createGeoPoint(condition: $condition, input: $input) {
      assetGroupId
      client
      createdAt
      description
      displayedChannels
      elevation
      geojson
      icon
      id
      imageUrl
      lat
      linkedComposedForecasts {
        nextToken
        __typename
      }
      linkedProcessedModelSchemas {
        nextToken
        __typename
      }
      lng
      name
      organizationId
      owner
      precipCurve {
        createdAt
        description
        id
        name
        organizationId
        organizationIds
        owner
        updatedAt
        xUnit
        yUnit
        __typename
      }
      precipCurveId
      processedModels {
        nextToken
        __typename
      }
      solarCurve {
        acCap
        arrayAzimuth
        arrayTilt
        createdAt
        dcCap
        description
        groundCoverRatio
        id
        maxTilt
        minIrradiance
        name
        owner
        panelEfficiency
        thermalLoss
        trackingType
        updatedAt
        xUnit
        yUnit
        __typename
      }
      solarCurveId
      tags
      updatedAt
      userGeoPointsId
      value {
        currency
        value
        __typename
      }
      windCurve {
        createdAt
        description
        id
        name
        organizationId
        organizationIds
        owner
        updatedAt
        xUnit
        yUnit
        __typename
      }
      windCurveId
      __typename
    }
  }
`;
export const createLlmResponse = /* GraphQL */ `
  mutation CreateLlmResponse(
    $condition: ModelLlmResponseConditionInput
    $input: CreateLlmResponseInput!
  ) {
    createLlmResponse(condition: $condition, input: $input) {
      conversation
      createdAt
      description
      executionTime
      id
      owner
      queryType
      response
      updatedAt
      uploadURL
      __typename
    }
  }
`;
export const createLoginAccessCodes = /* GraphQL */ `
  mutation CreateLoginAccessCodes(
    $condition: ModelLoginAccessCodesConditionInput
    $input: CreateLoginAccessCodesInput!
  ) {
    createLoginAccessCodes(condition: $condition, input: $input) {
      activatedBy
      available
      code
      createdAt
      notes
      recipient
      updatedAt
      __typename
    }
  }
`;
export const createMCPConversation = /* GraphQL */ `
  mutation CreateMCPConversation(
    $condition: ModelMCPConversationConditionInput
    $input: CreateMCPConversationInput!
  ) {
    createMCPConversation(condition: $condition, input: $input) {
      agentScheduleRunId
      agentScheduleRunnerId
      conversationType
      createdAt
      id
      isActive
      lastMessageAt
      messageCount
      messages {
        nextToken
        __typename
      }
      metadata
      model
      modelCodename
      organizationId
      owner
      projectId
      projectTaskId
      title
      totalTokens
      unreadCount
      updatedAt
      __typename
    }
  }
`;
export const createMCPMessage = /* GraphQL */ `
  mutation CreateMCPMessage(
    $condition: ModelMCPMessageConditionInput
    $input: CreateMCPMessageInput!
  ) {
    createMCPMessage(condition: $condition, input: $input) {
      attachments
      content
      conversation {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      conversationId
      createdAt
      enhancedPrompt
      executionTimeMs
      id
      inputTokens
      isUser
      messageRead
      model
      modelCodename
      organizationId
      outputTokens
      owner
      rating
      ratingComment
      rounds
      serverId
      sessionId
      status
      toolsCount
      updatedAt
      __typename
    }
  }
`;
export const createMCPSharedConversation = /* GraphQL */ `
  mutation CreateMCPSharedConversation(
    $condition: ModelMCPSharedConversationConditionInput
    $input: CreateMCPSharedConversationInput!
  ) {
    createMCPSharedConversation(condition: $condition, input: $input) {
      conversationId
      conversationType
      createdAt
      id
      includePrompts
      isActive
      messageId
      organizationId
      owner
      s3Key
      scheduleRunnerId
      scope
      title
      updatedAt
      __typename
    }
  }
`;
export const createMCPUsage = /* GraphQL */ `
  mutation CreateMCPUsage(
    $condition: ModelMCPUsageConditionInput
    $input: CreateMCPUsageInput!
  ) {
    createMCPUsage(condition: $condition, input: $input) {
      createdAt
      id
      period
      requestCount
      subscriptionTier
      tokenLimit
      tokensUsed
      updatedAt
      userId
      __typename
    }
  }
`;
export const createModelSchemaTemplate = /* GraphQL */ `
  mutation CreateModelSchemaTemplate(
    $condition: ModelModelSchemaTemplateConditionInput
    $input: CreateModelSchemaTemplateInput!
  ) {
    createModelSchemaTemplate(condition: $condition, input: $input) {
      authorProfileId
      authorType
      category
      createdAt
      createdBy
      description
      executionUrl
      external
      fieldDefinitions
      historicalConfig
      id
      isActive
      modelKind
      name
      profilePictureUrl
      requiresTraining
      tags
      trainingCost
      updatedAt
      version
      __typename
    }
  }
`;
export const createOrganization = /* GraphQL */ `
  mutation CreateOrganization(
    $condition: ModelOrganizationConditionInput
    $input: CreateOrganizationInput!
  ) {
    createOrganization(condition: $condition, input: $input) {
      createdAt
      description
      id
      members {
        nextToken
        __typename
      }
      name
      orgAiAnalystAccess
      owner
      profilePictureUrl
      updatedAt
      __typename
    }
  }
`;
export const createOrganizationPublicProfile = /* GraphQL */ `
  mutation CreateOrganizationPublicProfile(
    $condition: ModelOrganizationPublicProfileConditionInput
    $input: CreateOrganizationPublicProfileInput!
  ) {
    createOrganizationPublicProfile(condition: $condition, input: $input) {
      bio
      createdAt
      displayName
      email
      employees {
        nextToken
        __typename
      }
      id
      owner
      profilePictureUrl
      showBio
      showDisplayName
      showEmail
      showProfilePicture
      updatedAt
      __typename
    }
  }
`;
export const createPerformanceCurve = /* GraphQL */ `
  mutation CreatePerformanceCurve(
    $condition: ModelPerformanceCurveConditionInput
    $input: CreatePerformanceCurveInput!
  ) {
    createPerformanceCurve(condition: $condition, input: $input) {
      createdAt
      curveData {
        x
        y
        __typename
      }
      description
      id
      name
      organizationId
      organizationIds
      owner
      updatedAt
      xUnit
      yUnit
      __typename
    }
  }
`;
export const createProcessedModel = /* GraphQL */ `
  mutation CreateProcessedModel(
    $condition: ModelProcessedModelConditionInput
    $input: CreateProcessedModelInput!
  ) {
    createProcessedModel(condition: $condition, input: $input) {
      additionalDataPoints {
        color
        id
        lookbackDays
        name
        parameterId
        schema
        source
        __typename
      }
      assetId
      createdAt
      deliveryCron
      deliveryGraceMinutes
      deliveryMatchBy
      deliveryTimezone
      deliveryTrackingStartedAt
      description
      displayType
      geopoint {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      id
      label
      modelType
      organizationId
      owner
      routeLong
      routeShort
      schema
      updatedAt
      __typename
    }
  }
`;
export const createProcessedModelOutputParam = /* GraphQL */ `
  mutation CreateProcessedModelOutputParam(
    $condition: ModelProcessedModelOutputParamConditionInput
    $input: CreateProcessedModelOutputParamInput!
  ) {
    createProcessedModelOutputParam(condition: $condition, input: $input) {
      active
      channels
      createdAt
      description
      forecasts {
        nextToken
        __typename
      }
      id
      name
      organizationId
      outputLocation
      owner
      parameterTypeId
      schema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      schemaId
      seriesMetaData
      storageMode
      targetDatasetId
      unit
      updatedAt
      __typename
    }
  }
`;
export const createProcessedModelRunHistory = /* GraphQL */ `
  mutation CreateProcessedModelRunHistory(
    $condition: ModelProcessedModelRunHistoryConditionInput
    $input: CreateProcessedModelRunHistoryInput!
  ) {
    createProcessedModelRunHistory(condition: $condition, input: $input) {
      acknowledged
      acknowledgedAt
      acknowledgedBy
      attempt
      completedAt
      createdAt
      description
      executionTimeMs
      forecasts {
        nextToken
        __typename
      }
      id
      inputs
      modelSchemaTemplateId
      organizationId
      outputS3Keys
      owner
      processedModelScheduleId
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaId
      requestId
      startedAt
      status
      triggerType
      updatedAt
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const createProcessedModelRunRequest = /* GraphQL */ `
  mutation CreateProcessedModelRunRequest(
    $condition: ModelProcessedModelRunRequestConditionInput
    $input: CreateProcessedModelRunRequestInput!
  ) {
    createProcessedModelRunRequest(condition: $condition, input: $input) {
      attempts
      backfillId
      chunkCount
      chunkIndex
      completedAt
      createdAt
      error
      id
      mergedInto
      notBefore
      organizationId
      owner
      processedModelSchemaId
      runIds
      startedAt
      status
      triggerRef
      triggerType
      updatedAt
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const createProcessedModelSchedule = /* GraphQL */ `
  mutation CreateProcessedModelSchedule(
    $condition: ModelProcessedModelScheduleConditionInput
    $input: CreateProcessedModelScheduleInput!
  ) {
    createProcessedModelSchedule(condition: $condition, input: $input) {
      createdAt
      cronExpression
      firstRunTime
      frequency
      id
      lastRunAt
      nextRunAt
      organizationId
      owner
      processedModelSchemaId
      runCount
      status
      timezone
      updatedAt
      __typename
    }
  }
`;
export const createProcessedModelSchema = /* GraphQL */ `
  mutation CreateProcessedModelSchema(
    $condition: ModelProcessedModelSchemaConditionInput
    $input: CreateProcessedModelSchemaInput!
  ) {
    createProcessedModelSchema(condition: $condition, input: $input) {
      activeStatus
      createdAt
      dataSources {
        nextToken
        __typename
      }
      deliveryExpectation
      dependency
      description
      executionUrl
      historicalSettings
      id
      isActive
      linkedAssetGroups {
        nextToken
        __typename
      }
      linkedAssets {
        nextToken
        __typename
      }
      linkedDatasets {
        nextToken
        __typename
      }
      linkedOutputs {
        nextToken
        __typename
      }
      modelKind
      name
      organizationId
      outputs {
        nextToken
        __typename
      }
      owner
      runHistory {
        nextToken
        __typename
      }
      runSchedule
      s3BasePath
      schemaFields
      schemaType
      type
      updatedAt
      version
      __typename
    }
  }
`;
export const createProcessedModelSchemaAssetGroups = /* GraphQL */ `
  mutation CreateProcessedModelSchemaAssetGroups(
    $condition: ModelProcessedModelSchemaAssetGroupsConditionInput
    $input: CreateProcessedModelSchemaAssetGroupsInput!
  ) {
    createProcessedModelSchemaAssetGroups(
      condition: $condition
      input: $input
    ) {
      assetGroup {
        createdAt
        description
        displayedChannels
        id
        name
        organizationId
        owner
        profilePictureUrl
        updatedAt
        userAssetGroupsId
        __typename
      }
      assetGroupID
      createdAt
      id
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaID
      updatedAt
      __typename
    }
  }
`;
export const createProcessedModelSchemaAssets = /* GraphQL */ `
  mutation CreateProcessedModelSchemaAssets(
    $condition: ModelProcessedModelSchemaAssetsConditionInput
    $input: CreateProcessedModelSchemaAssetsInput!
  ) {
    createProcessedModelSchemaAssets(condition: $condition, input: $input) {
      asset {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      assetID
      createdAt
      id
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaID
      updatedAt
      __typename
    }
  }
`;
export const createProcessedModelV1EmailLog = /* GraphQL */ `
  mutation CreateProcessedModelV1EmailLog(
    $condition: ModelProcessedModelV1EmailLogConditionInput
    $input: CreateProcessedModelV1EmailLogInput!
  ) {
    createProcessedModelV1EmailLog(condition: $condition, input: $input) {
      assetCount
      assetNames
      ccRecipientCount
      chartsRendered
      completedAt
      createdAt
      errorMessage
      id
      recipientCount
      scheduleId
      startedAt
      status
      updatedAt
      __typename
    }
  }
`;
export const createProcessedModelV1EmailSchedule = /* GraphQL */ `
  mutation CreateProcessedModelV1EmailSchedule(
    $condition: ModelProcessedModelV1EmailScheduleConditionInput
    $input: CreateProcessedModelV1EmailScheduleInput!
  ) {
    createProcessedModelV1EmailSchedule(condition: $condition, input: $input) {
      ccRecipients
      createdAt
      cronExpression
      firstRunTime
      frequency
      id
      label
      lastRunAt
      nextRunAt
      organizationId
      owner
      recipients
      runCount
      status
      targets {
        assetId
        assetName
        __typename
      }
      timezone
      updatedAt
      __typename
    }
  }
`;
export const createPublicProfile = /* GraphQL */ `
  mutation CreatePublicProfile(
    $condition: ModelPublicProfileConditionInput
    $input: CreatePublicProfileInput!
  ) {
    createPublicProfile(condition: $condition, input: $input) {
      bio
      createdAt
      displayName
      email
      id
      organizationProfileId
      owner
      profilePictureUrl
      showBio
      showDisplayName
      showEmail
      showProfilePicture
      updatedAt
      __typename
    }
  }
`;
export const createSolarEnergyModel = /* GraphQL */ `
  mutation CreateSolarEnergyModel(
    $condition: ModelSolarEnergyModelConditionInput
    $input: CreateSolarEnergyModelInput!
  ) {
    createSolarEnergyModel(condition: $condition, input: $input) {
      acCap
      arrayAzimuth
      arrayTilt
      createdAt
      dcCap
      description
      groundCoverRatio
      id
      maxTilt
      minIrradiance
      name
      owner
      panelEfficiency
      thermalLoss
      trackingType
      updatedAt
      xUnit
      yUnit
      __typename
    }
  }
`;
export const createSystemPrompt = /* GraphQL */ `
  mutation CreateSystemPrompt(
    $condition: ModelSystemPromptConditionInput
    $input: CreateSystemPromptInput!
  ) {
    createSystemPrompt(condition: $condition, input: $input) {
      createdAt
      description
      id
      isDefault
      model
      promptText
      rating
      surface
      updatedAt
      __typename
    }
  }
`;
export const createUploadData = /* GraphQL */ `
  mutation CreateUploadData(
    $condition: ModelUploadDataConditionInput
    $input: CreateUploadDataInput!
  ) {
    createUploadData(condition: $condition, input: $input) {
      createdAt
      description
      fileLocation
      id
      name
      objective
      optimizationHorizon
      owner
      parameter
      seasonality
      temporalResolution
      updatedAt
      __typename
    }
  }
`;
export const createUser = /* GraphQL */ `
  mutation CreateUser(
    $condition: ModelUserConditionInput
    $input: CreateUserInput!
  ) {
    createUser(condition: $condition, input: $input) {
      assetCount
      assetGroupCount
      assetGroups {
        nextToken
        __typename
      }
      chatPrivacyPolicyAccepted
      chatPrivacyPolicyLocation
      cognitoIdentityId
      createdAt
      email
      geoPoints {
        nextToken
        __typename
      }
      id
      name
      organizationIds
      organizations {
        nextToken
        __typename
      }
      personas {
        nextToken
        __typename
      }
      preferredPersona {
        completed
        createdAt
        description
        id
        markets
        name
        owner
        regions
        selectedNeeds
        summary
        updatedAt
        userId
        __typename
      }
      preferredPersonaId
      privacyPolicyAuditTrail
      profilePictureUrl
      termsAndConditionsAuditTrail
      termsAndConditionsLocation
      termsAndConditionsReviewed
      tourAssetSeen
      tourChatCompleted
      tourGroupSeen
      tourOnboardingGuidanceSent
      tourWelcomeShown
      updatedAt
      userConsent
      username
      __typename
    }
  }
`;
export const createUserChecklistProgress = /* GraphQL */ `
  mutation CreateUserChecklistProgress(
    $condition: ModelUserChecklistProgressConditionInput
    $input: CreateUserChecklistProgressInput!
  ) {
    createUserChecklistProgress(condition: $condition, input: $input) {
      createdAt
      hatUnlocked
      id
      loginDates
      owner
      shippingAddress
      step1Complete
      step2Complete
      step3Complete
      step4Complete
      step5Complete
      step6Complete
      updatedAt
      userId
      welcomeShown
      __typename
    }
  }
`;
export const createUserOrganizations = /* GraphQL */ `
  mutation CreateUserOrganizations(
    $condition: ModelUserOrganizationsConditionInput
    $input: CreateUserOrganizationsInput!
  ) {
    createUserOrganizations(condition: $condition, input: $input) {
      createdAt
      id
      organization {
        createdAt
        description
        id
        name
        orgAiAnalystAccess
        owner
        profilePictureUrl
        updatedAt
        __typename
      }
      organizationId
      owner
      updatedAt
      user {
        assetCount
        assetGroupCount
        chatPrivacyPolicyAccepted
        chatPrivacyPolicyLocation
        cognitoIdentityId
        createdAt
        email
        id
        name
        organizationIds
        preferredPersonaId
        privacyPolicyAuditTrail
        profilePictureUrl
        termsAndConditionsAuditTrail
        termsAndConditionsLocation
        termsAndConditionsReviewed
        tourAssetSeen
        tourChatCompleted
        tourGroupSeen
        tourOnboardingGuidanceSent
        tourWelcomeShown
        updatedAt
        userConsent
        username
        __typename
      }
      userID
      __typename
    }
  }
`;
export const createUserPersona = /* GraphQL */ `
  mutation CreateUserPersona(
    $condition: ModelUserPersonaConditionInput
    $input: CreateUserPersonaInput!
  ) {
    createUserPersona(condition: $condition, input: $input) {
      completed
      createdAt
      description
      id
      markets
      name
      owner
      regions
      selectedNeeds
      summary
      updatedAt
      user {
        assetCount
        assetGroupCount
        chatPrivacyPolicyAccepted
        chatPrivacyPolicyLocation
        cognitoIdentityId
        createdAt
        email
        id
        name
        organizationIds
        preferredPersonaId
        privacyPolicyAuditTrail
        profilePictureUrl
        termsAndConditionsAuditTrail
        termsAndConditionsLocation
        termsAndConditionsReviewed
        tourAssetSeen
        tourChatCompleted
        tourGroupSeen
        tourOnboardingGuidanceSent
        tourWelcomeShown
        updatedAt
        userConsent
        username
        __typename
      }
      userId
      __typename
    }
  }
`;
export const createUserProject = /* GraphQL */ `
  mutation CreateUserProject(
    $condition: ModelUserProjectConditionInput
    $input: CreateUserProjectInput!
  ) {
    createUserProject(condition: $condition, input: $input) {
      createdAt
      datasetIds
      description
      id
      imageUrl
      organizationId
      owner
      tasks {
        nextToken
        __typename
      }
      title
      updatedAt
      __typename
    }
  }
`;
export const createUserProjectTask = /* GraphQL */ `
  mutation CreateUserProjectTask(
    $condition: ModelUserProjectTaskConditionInput
    $input: CreateUserProjectTaskInput!
  ) {
    createUserProjectTask(condition: $condition, input: $input) {
      completedTask
      createdAt
      description
      id
      order
      owner
      project {
        createdAt
        datasetIds
        description
        id
        imageUrl
        organizationId
        owner
        title
        updatedAt
        __typename
      }
      projectId
      title
      updatedAt
      __typename
    }
  }
`;
export const createUserSubscription = /* GraphQL */ `
  mutation CreateUserSubscription(
    $condition: ModelUserSubscriptionConditionInput
    $input: CreateUserSubscriptionInput!
  ) {
    createUserSubscription(condition: $condition, input: $input) {
      cancelAt
      cancelAtPeriodEnd
      createdAt
      currentPeriodEnd
      customerId
      entitlements
      id
      items
      lastPaymentDate
      lastPaymentStatus
      livemode
      owner
      status
      updatedAt
      __typename
    }
  }
`;
export const createUserTokenGrant = /* GraphQL */ `
  mutation CreateUserTokenGrant(
    $condition: ModelUserTokenGrantConditionInput
    $input: CreateUserTokenGrantInput!
  ) {
    createUserTokenGrant(condition: $condition, input: $input) {
      active
      createdAt
      email
      expiresAt
      grantedBy
      id
      notes
      tokenLimit
      updatedAt
      __typename
    }
  }
`;
export const deleteAccessRequest = /* GraphQL */ `
  mutation DeleteAccessRequest(
    $condition: ModelAccessRequestConditionInput
    $input: DeleteAccessRequestInput!
  ) {
    deleteAccessRequest(condition: $condition, input: $input) {
      adminNotes
      createdAt
      description
      email
      id
      owner
      status
      updatedAt
      __typename
    }
  }
`;
export const deleteAgentSchedule = /* GraphQL */ `
  mutation DeleteAgentSchedule(
    $condition: ModelAgentScheduleConditionInput
    $input: DeleteAgentScheduleInput!
  ) {
    deleteAgentSchedule(condition: $condition, input: $input) {
      createdAt
      cronExpression
      description
      error
      id
      lastRunAt
      metadata
      nextRunAt
      organizationId
      owner
      projectId
      runCount
      runners {
        nextToken
        __typename
      }
      runs {
        nextToken
        __typename
      }
      runtime
      status
      systemPrompt
      timezone
      title
      updatedAt
      __typename
    }
  }
`;
export const deleteAgentScheduleRun = /* GraphQL */ `
  mutation DeleteAgentScheduleRun(
    $condition: ModelAgentScheduleRunConditionInput
    $input: DeleteAgentScheduleRunInput!
  ) {
    deleteAgentScheduleRun(condition: $condition, input: $input) {
      conversations {
        nextToken
        __typename
      }
      createdAt
      error
      id
      organizationId
      owner
      schedule {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      scheduleId
      status
      updatedAt
      __typename
    }
  }
`;
export const deleteAgentScheduleRunner = /* GraphQL */ `
  mutation DeleteAgentScheduleRunner(
    $condition: ModelAgentScheduleRunnerConditionInput
    $input: DeleteAgentScheduleRunnerInput!
  ) {
    deleteAgentScheduleRunner(condition: $condition, input: $input) {
      attachments
      conversations {
        nextToken
        __typename
      }
      createdAt
      emailCondition
      emailConditionMode
      id
      organizationId
      owner
      prompt
      schedule {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      scheduleId
      sendEmail
      sortOrder
      title
      updatedAt
      __typename
    }
  }
`;
export const deleteApiIdempotencyKey = /* GraphQL */ `
  mutation DeleteApiIdempotencyKey(
    $condition: ModelApiIdempotencyKeyConditionInput
    $input: DeleteApiIdempotencyKeyInput!
  ) {
    deleteApiIdempotencyKey(condition: $condition, input: $input) {
      claimToken
      createdAt
      expiresAt
      id
      owner
      requestHash
      response
      responseStatus
      route
      status
      updatedAt
      __typename
    }
  }
`;
export const deleteAssetGroup = /* GraphQL */ `
  mutation DeleteAssetGroup(
    $condition: ModelAssetGroupConditionInput
    $input: DeleteAssetGroupInput!
  ) {
    deleteAssetGroup(condition: $condition, input: $input) {
      assets {
        nextToken
        __typename
      }
      createdAt
      description
      displayedChannels
      id
      linkedProcessedModelSchemas {
        nextToken
        __typename
      }
      name
      organizationId
      owner
      profilePictureUrl
      updatedAt
      userAssetGroupsId
      __typename
    }
  }
`;
export const deleteComposedForecast = /* GraphQL */ `
  mutation DeleteComposedForecast(
    $condition: ModelComposedForecastConditionInput
    $input: DeleteComposedForecastInput!
  ) {
    deleteComposedForecast(condition: $condition, input: $input) {
      aggregationMethod
      createdAt
      dataSources {
        nextToken
        __typename
      }
      description
      forecastHorizon
      forecastType
      id
      isActive
      lastProcessed
      linkedAssets {
        nextToken
        __typename
      }
      name
      organizationId
      outputParameters
      owner
      processingSchedule
      updateFrequency
      updatedAt
      validationThresholds
      __typename
    }
  }
`;
export const deleteComposedForecastAssets = /* GraphQL */ `
  mutation DeleteComposedForecastAssets(
    $condition: ModelComposedForecastAssetsConditionInput
    $input: DeleteComposedForecastAssetsInput!
  ) {
    deleteComposedForecastAssets(condition: $condition, input: $input) {
      asset {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      assetID
      composedForecast {
        aggregationMethod
        createdAt
        description
        forecastHorizon
        forecastType
        id
        isActive
        lastProcessed
        name
        organizationId
        outputParameters
        owner
        processingSchedule
        updateFrequency
        updatedAt
        validationThresholds
        __typename
      }
      composedForecastID
      createdAt
      icon
      id
      isDefault
      organizationId
      owner
      updatedAt
      __typename
    }
  }
`;
export const deleteComposedForecastDataSource = /* GraphQL */ `
  mutation DeleteComposedForecastDataSource(
    $condition: ModelComposedForecastDataSourceConditionInput
    $input: DeleteComposedForecastDataSourceInput!
  ) {
    deleteComposedForecastDataSource(condition: $condition, input: $input) {
      composedForecast {
        aggregationMethod
        createdAt
        description
        forecastHorizon
        forecastType
        id
        isActive
        lastProcessed
        name
        organizationId
        outputParameters
        owner
        processingSchedule
        updateFrequency
        updatedAt
        validationThresholds
        __typename
      }
      composedForecastId
      createdAt
      dataOperations
      dataQualityScore
      externalApiEndpoint
      externalApiHeaders
      externalApiKey
      externalApiParams
      fallbackStrategy
      fallbackValue
      fetchErrorMessage
      groundTruthSensorId
      groundTruthTableName
      id
      isActive
      lastFetchStatus
      lastFetchedAt
      metadata
      modelOutputTimeOffset
      organizationId
      owner
      postgresAggregation
      postgresColumns
      postgresQuery
      postgresTable
      postgresTimeRange
      priority
      processedModelOutput {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      processedModelOutputId
      projectId
      s3FileFormat
      s3Location
      s3ParseConfig
      sourceDescription
      sourceName
      sourceType
      temporalResolution
      timeAlignment
      timeLag
      transformations
      updatedAt
      validationRules
      weight
      zarrCoordinates
      zarrPath
      zarrTimeSelection
      zarrVariable
      __typename
    }
  }
`;
export const deleteDataSetRecord = /* GraphQL */ `
  mutation DeleteDataSetRecord(
    $condition: ModelDataSetRecordConditionInput
    $input: DeleteDataSetRecordInput!
  ) {
    deleteDataSetRecord(condition: $condition, input: $input) {
      columns
      compressedSize
      compressionType
      createdAt
      dataset {
        columns
        createdAt
        curationMode
        datasetType
        deletedAt
        description
        duplicatePolicy
        fileFormat
        fileSize
        id
        ingestMetadata
        lastUpdated
        linkedAssets
        linkedSchemas
        location
        locationId
        name
        organizationId
        owner
        parameterType
        profilePictureUrl
        recordCount
        routeLong
        slug
        sourceModelId
        tags
        timeRange
        units
        updateFrequency
        updatedAt
        userId
        __typename
      }
      datasetId
      fileName
      fileSize
      id
      organizationId
      owner
      recordCount
      s3Path
      timeRange
      timeValue
      updatedAt
      uploadId
      uploadedAt
      uploadedBy
      uploadedByEmail
      __typename
    }
  }
`;
export const deleteDataSource = /* GraphQL */ `
  mutation DeleteDataSource(
    $condition: ModelDataSourceConditionInput
    $input: DeleteDataSourceInput!
  ) {
    deleteDataSource(condition: $condition, input: $input) {
      createdAt
      dataOperations
      databaseTable
      format
      id
      isGroundTruth
      metadata
      name
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaId
      s3Path
      sourceType
      updatedAt
      __typename
    }
  }
`;
export const deleteDataset = /* GraphQL */ `
  mutation DeleteDataset(
    $condition: ModelDatasetConditionInput
    $input: DeleteDatasetInput!
  ) {
    deleteDataset(condition: $condition, input: $input) {
      columns
      createdAt
      curationMode
      datasetType
      deletedAt
      description
      duplicatePolicy
      fileFormat
      fileSize
      id
      ingestMetadata
      lastUpdated
      linkedAssets
      linkedSchemas
      location
      locationId
      name
      organizationId
      owner
      parameterType
      profilePictureUrl
      recordCount
      records {
        nextToken
        __typename
      }
      routeLong
      slug
      sourceModelId
      tags
      timeRange
      units
      updateFrequency
      updatedAt
      userId
      __typename
    }
  }
`;
export const deleteDatasetUpload = /* GraphQL */ `
  mutation DeleteDatasetUpload(
    $condition: ModelDatasetUploadConditionInput
    $input: DeleteDatasetUploadInput!
  ) {
    deleteDatasetUpload(condition: $condition, input: $input) {
      columnMetadata
      columnSources
      columns
      createdAt
      datasetId
      duplicateTimestamps
      failureReason
      fileName
      id
      incomingKey
      inputsReadAt
      organizationId
      outputParamId
      owner
      processedAt
      processedModelSchemaId
      rawKey
      receivedAt
      recordId
      rejectedKey
      requestedAt
      rowCount
      runId
      sizeBytes
      source
      sourceTimezone
      status
      timeRange
      updatedAt
      uploadedBy
      uploadedByEmail
      validationErrors
      warnings
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const deleteErrorLog = /* GraphQL */ `
  mutation DeleteErrorLog(
    $condition: ModelErrorLogConditionInput
    $input: DeleteErrorLogInput!
  ) {
    deleteErrorLog(condition: $condition, input: $input) {
      adminNotes
      cognitoIdentityId
      createdAt
      description
      id
      images
      mcpConversationId
      mcpMessageId
      owner
      pageUrl
      source
      status
      updatedAt
      userEmail
      __typename
    }
  }
`;
export const deleteForecastRecord = /* GraphQL */ `
  mutation DeleteForecastRecord(
    $condition: ModelForecastRecordConditionInput
    $input: DeleteForecastRecordInput!
  ) {
    deleteForecastRecord(condition: $condition, input: $input) {
      createdAt
      forecastIssued
      id
      inputs
      metadata
      organizationId
      owner
      parameter {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      parameterId
      run {
        acknowledged
        acknowledgedAt
        acknowledgedBy
        attempt
        completedAt
        createdAt
        description
        executionTimeMs
        id
        inputs
        modelSchemaTemplateId
        organizationId
        outputS3Keys
        owner
        processedModelScheduleId
        processedModelSchemaId
        requestId
        startedAt
        status
        triggerType
        updatedAt
        windowEnd
        windowStart
        __typename
      }
      runId
      s3Key
      seriesEnd
      seriesMetaData
      seriesStart
      source
      updatedAt
      uploadId
      uploadedBy
      __typename
    }
  }
`;
export const deleteForecastReport = /* GraphQL */ `
  mutation DeleteForecastReport(
    $condition: ModelForecastReportConditionInput
    $input: DeleteForecastReportInput!
  ) {
    deleteForecastReport(condition: $condition, input: $input) {
      completedAt
      config
      createdAt
      description
      error
      id
      identityId
      name
      organizationId
      owner
      progress
      resultS3Key
      startedAt
      status
      summary
      updatedAt
      __typename
    }
  }
`;
export const deleteForecastUpload = /* GraphQL */ `
  mutation DeleteForecastUpload(
    $condition: ModelForecastUploadConditionInput
    $input: DeleteForecastUploadInput!
  ) {
    deleteForecastUpload(condition: $condition, input: $input) {
      createdAt
      failureReason
      fileName
      finalKey
      forecastIssued
      forecastRecordId
      id
      incomingKey
      issueTime
      organizationId
      outputParamId
      owner
      parameters
      processedAt
      rawKey
      receivedAt
      requestedAt
      rowCount
      schemaId
      sizeBytes
      source
      status
      timeRange
      updatedAt
      uploadedBy
      uploadedByEmail
      validationErrors
      warnings
      __typename
    }
  }
`;
export const deleteGeoPoint = /* GraphQL */ `
  mutation DeleteGeoPoint(
    $condition: ModelGeoPointConditionInput
    $input: DeleteGeoPointInput!
  ) {
    deleteGeoPoint(condition: $condition, input: $input) {
      assetGroupId
      client
      createdAt
      description
      displayedChannels
      elevation
      geojson
      icon
      id
      imageUrl
      lat
      linkedComposedForecasts {
        nextToken
        __typename
      }
      linkedProcessedModelSchemas {
        nextToken
        __typename
      }
      lng
      name
      organizationId
      owner
      precipCurve {
        createdAt
        description
        id
        name
        organizationId
        organizationIds
        owner
        updatedAt
        xUnit
        yUnit
        __typename
      }
      precipCurveId
      processedModels {
        nextToken
        __typename
      }
      solarCurve {
        acCap
        arrayAzimuth
        arrayTilt
        createdAt
        dcCap
        description
        groundCoverRatio
        id
        maxTilt
        minIrradiance
        name
        owner
        panelEfficiency
        thermalLoss
        trackingType
        updatedAt
        xUnit
        yUnit
        __typename
      }
      solarCurveId
      tags
      updatedAt
      userGeoPointsId
      value {
        currency
        value
        __typename
      }
      windCurve {
        createdAt
        description
        id
        name
        organizationId
        organizationIds
        owner
        updatedAt
        xUnit
        yUnit
        __typename
      }
      windCurveId
      __typename
    }
  }
`;
export const deleteLlmResponse = /* GraphQL */ `
  mutation DeleteLlmResponse(
    $condition: ModelLlmResponseConditionInput
    $input: DeleteLlmResponseInput!
  ) {
    deleteLlmResponse(condition: $condition, input: $input) {
      conversation
      createdAt
      description
      executionTime
      id
      owner
      queryType
      response
      updatedAt
      uploadURL
      __typename
    }
  }
`;
export const deleteLoginAccessCodes = /* GraphQL */ `
  mutation DeleteLoginAccessCodes(
    $condition: ModelLoginAccessCodesConditionInput
    $input: DeleteLoginAccessCodesInput!
  ) {
    deleteLoginAccessCodes(condition: $condition, input: $input) {
      activatedBy
      available
      code
      createdAt
      notes
      recipient
      updatedAt
      __typename
    }
  }
`;
export const deleteMCPConversation = /* GraphQL */ `
  mutation DeleteMCPConversation(
    $condition: ModelMCPConversationConditionInput
    $input: DeleteMCPConversationInput!
  ) {
    deleteMCPConversation(condition: $condition, input: $input) {
      agentScheduleRunId
      agentScheduleRunnerId
      conversationType
      createdAt
      id
      isActive
      lastMessageAt
      messageCount
      messages {
        nextToken
        __typename
      }
      metadata
      model
      modelCodename
      organizationId
      owner
      projectId
      projectTaskId
      title
      totalTokens
      unreadCount
      updatedAt
      __typename
    }
  }
`;
export const deleteMCPMessage = /* GraphQL */ `
  mutation DeleteMCPMessage(
    $condition: ModelMCPMessageConditionInput
    $input: DeleteMCPMessageInput!
  ) {
    deleteMCPMessage(condition: $condition, input: $input) {
      attachments
      content
      conversation {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      conversationId
      createdAt
      enhancedPrompt
      executionTimeMs
      id
      inputTokens
      isUser
      messageRead
      model
      modelCodename
      organizationId
      outputTokens
      owner
      rating
      ratingComment
      rounds
      serverId
      sessionId
      status
      toolsCount
      updatedAt
      __typename
    }
  }
`;
export const deleteMCPSharedConversation = /* GraphQL */ `
  mutation DeleteMCPSharedConversation(
    $condition: ModelMCPSharedConversationConditionInput
    $input: DeleteMCPSharedConversationInput!
  ) {
    deleteMCPSharedConversation(condition: $condition, input: $input) {
      conversationId
      conversationType
      createdAt
      id
      includePrompts
      isActive
      messageId
      organizationId
      owner
      s3Key
      scheduleRunnerId
      scope
      title
      updatedAt
      __typename
    }
  }
`;
export const deleteMCPUsage = /* GraphQL */ `
  mutation DeleteMCPUsage(
    $condition: ModelMCPUsageConditionInput
    $input: DeleteMCPUsageInput!
  ) {
    deleteMCPUsage(condition: $condition, input: $input) {
      createdAt
      id
      period
      requestCount
      subscriptionTier
      tokenLimit
      tokensUsed
      updatedAt
      userId
      __typename
    }
  }
`;
export const deleteModelSchemaTemplate = /* GraphQL */ `
  mutation DeleteModelSchemaTemplate(
    $condition: ModelModelSchemaTemplateConditionInput
    $input: DeleteModelSchemaTemplateInput!
  ) {
    deleteModelSchemaTemplate(condition: $condition, input: $input) {
      authorProfileId
      authorType
      category
      createdAt
      createdBy
      description
      executionUrl
      external
      fieldDefinitions
      historicalConfig
      id
      isActive
      modelKind
      name
      profilePictureUrl
      requiresTraining
      tags
      trainingCost
      updatedAt
      version
      __typename
    }
  }
`;
export const deleteOrganization = /* GraphQL */ `
  mutation DeleteOrganization(
    $condition: ModelOrganizationConditionInput
    $input: DeleteOrganizationInput!
  ) {
    deleteOrganization(condition: $condition, input: $input) {
      createdAt
      description
      id
      members {
        nextToken
        __typename
      }
      name
      orgAiAnalystAccess
      owner
      profilePictureUrl
      updatedAt
      __typename
    }
  }
`;
export const deleteOrganizationPublicProfile = /* GraphQL */ `
  mutation DeleteOrganizationPublicProfile(
    $condition: ModelOrganizationPublicProfileConditionInput
    $input: DeleteOrganizationPublicProfileInput!
  ) {
    deleteOrganizationPublicProfile(condition: $condition, input: $input) {
      bio
      createdAt
      displayName
      email
      employees {
        nextToken
        __typename
      }
      id
      owner
      profilePictureUrl
      showBio
      showDisplayName
      showEmail
      showProfilePicture
      updatedAt
      __typename
    }
  }
`;
export const deletePerformanceCurve = /* GraphQL */ `
  mutation DeletePerformanceCurve(
    $condition: ModelPerformanceCurveConditionInput
    $input: DeletePerformanceCurveInput!
  ) {
    deletePerformanceCurve(condition: $condition, input: $input) {
      createdAt
      curveData {
        x
        y
        __typename
      }
      description
      id
      name
      organizationId
      organizationIds
      owner
      updatedAt
      xUnit
      yUnit
      __typename
    }
  }
`;
export const deleteProcessedModel = /* GraphQL */ `
  mutation DeleteProcessedModel(
    $condition: ModelProcessedModelConditionInput
    $input: DeleteProcessedModelInput!
  ) {
    deleteProcessedModel(condition: $condition, input: $input) {
      additionalDataPoints {
        color
        id
        lookbackDays
        name
        parameterId
        schema
        source
        __typename
      }
      assetId
      createdAt
      deliveryCron
      deliveryGraceMinutes
      deliveryMatchBy
      deliveryTimezone
      deliveryTrackingStartedAt
      description
      displayType
      geopoint {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      id
      label
      modelType
      organizationId
      owner
      routeLong
      routeShort
      schema
      updatedAt
      __typename
    }
  }
`;
export const deleteProcessedModelOutputParam = /* GraphQL */ `
  mutation DeleteProcessedModelOutputParam(
    $condition: ModelProcessedModelOutputParamConditionInput
    $input: DeleteProcessedModelOutputParamInput!
  ) {
    deleteProcessedModelOutputParam(condition: $condition, input: $input) {
      active
      channels
      createdAt
      description
      forecasts {
        nextToken
        __typename
      }
      id
      name
      organizationId
      outputLocation
      owner
      parameterTypeId
      schema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      schemaId
      seriesMetaData
      storageMode
      targetDatasetId
      unit
      updatedAt
      __typename
    }
  }
`;
export const deleteProcessedModelRunHistory = /* GraphQL */ `
  mutation DeleteProcessedModelRunHistory(
    $condition: ModelProcessedModelRunHistoryConditionInput
    $input: DeleteProcessedModelRunHistoryInput!
  ) {
    deleteProcessedModelRunHistory(condition: $condition, input: $input) {
      acknowledged
      acknowledgedAt
      acknowledgedBy
      attempt
      completedAt
      createdAt
      description
      executionTimeMs
      forecasts {
        nextToken
        __typename
      }
      id
      inputs
      modelSchemaTemplateId
      organizationId
      outputS3Keys
      owner
      processedModelScheduleId
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaId
      requestId
      startedAt
      status
      triggerType
      updatedAt
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const deleteProcessedModelRunRequest = /* GraphQL */ `
  mutation DeleteProcessedModelRunRequest(
    $condition: ModelProcessedModelRunRequestConditionInput
    $input: DeleteProcessedModelRunRequestInput!
  ) {
    deleteProcessedModelRunRequest(condition: $condition, input: $input) {
      attempts
      backfillId
      chunkCount
      chunkIndex
      completedAt
      createdAt
      error
      id
      mergedInto
      notBefore
      organizationId
      owner
      processedModelSchemaId
      runIds
      startedAt
      status
      triggerRef
      triggerType
      updatedAt
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const deleteProcessedModelSchedule = /* GraphQL */ `
  mutation DeleteProcessedModelSchedule(
    $condition: ModelProcessedModelScheduleConditionInput
    $input: DeleteProcessedModelScheduleInput!
  ) {
    deleteProcessedModelSchedule(condition: $condition, input: $input) {
      createdAt
      cronExpression
      firstRunTime
      frequency
      id
      lastRunAt
      nextRunAt
      organizationId
      owner
      processedModelSchemaId
      runCount
      status
      timezone
      updatedAt
      __typename
    }
  }
`;
export const deleteProcessedModelSchema = /* GraphQL */ `
  mutation DeleteProcessedModelSchema(
    $condition: ModelProcessedModelSchemaConditionInput
    $input: DeleteProcessedModelSchemaInput!
  ) {
    deleteProcessedModelSchema(condition: $condition, input: $input) {
      activeStatus
      createdAt
      dataSources {
        nextToken
        __typename
      }
      deliveryExpectation
      dependency
      description
      executionUrl
      historicalSettings
      id
      isActive
      linkedAssetGroups {
        nextToken
        __typename
      }
      linkedAssets {
        nextToken
        __typename
      }
      linkedDatasets {
        nextToken
        __typename
      }
      linkedOutputs {
        nextToken
        __typename
      }
      modelKind
      name
      organizationId
      outputs {
        nextToken
        __typename
      }
      owner
      runHistory {
        nextToken
        __typename
      }
      runSchedule
      s3BasePath
      schemaFields
      schemaType
      type
      updatedAt
      version
      __typename
    }
  }
`;
export const deleteProcessedModelSchemaAssetGroups = /* GraphQL */ `
  mutation DeleteProcessedModelSchemaAssetGroups(
    $condition: ModelProcessedModelSchemaAssetGroupsConditionInput
    $input: DeleteProcessedModelSchemaAssetGroupsInput!
  ) {
    deleteProcessedModelSchemaAssetGroups(
      condition: $condition
      input: $input
    ) {
      assetGroup {
        createdAt
        description
        displayedChannels
        id
        name
        organizationId
        owner
        profilePictureUrl
        updatedAt
        userAssetGroupsId
        __typename
      }
      assetGroupID
      createdAt
      id
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaID
      updatedAt
      __typename
    }
  }
`;
export const deleteProcessedModelSchemaAssets = /* GraphQL */ `
  mutation DeleteProcessedModelSchemaAssets(
    $condition: ModelProcessedModelSchemaAssetsConditionInput
    $input: DeleteProcessedModelSchemaAssetsInput!
  ) {
    deleteProcessedModelSchemaAssets(condition: $condition, input: $input) {
      asset {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      assetID
      createdAt
      id
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaID
      updatedAt
      __typename
    }
  }
`;
export const deleteProcessedModelV1EmailLog = /* GraphQL */ `
  mutation DeleteProcessedModelV1EmailLog(
    $condition: ModelProcessedModelV1EmailLogConditionInput
    $input: DeleteProcessedModelV1EmailLogInput!
  ) {
    deleteProcessedModelV1EmailLog(condition: $condition, input: $input) {
      assetCount
      assetNames
      ccRecipientCount
      chartsRendered
      completedAt
      createdAt
      errorMessage
      id
      recipientCount
      scheduleId
      startedAt
      status
      updatedAt
      __typename
    }
  }
`;
export const deleteProcessedModelV1EmailSchedule = /* GraphQL */ `
  mutation DeleteProcessedModelV1EmailSchedule(
    $condition: ModelProcessedModelV1EmailScheduleConditionInput
    $input: DeleteProcessedModelV1EmailScheduleInput!
  ) {
    deleteProcessedModelV1EmailSchedule(condition: $condition, input: $input) {
      ccRecipients
      createdAt
      cronExpression
      firstRunTime
      frequency
      id
      label
      lastRunAt
      nextRunAt
      organizationId
      owner
      recipients
      runCount
      status
      targets {
        assetId
        assetName
        __typename
      }
      timezone
      updatedAt
      __typename
    }
  }
`;
export const deletePublicProfile = /* GraphQL */ `
  mutation DeletePublicProfile(
    $condition: ModelPublicProfileConditionInput
    $input: DeletePublicProfileInput!
  ) {
    deletePublicProfile(condition: $condition, input: $input) {
      bio
      createdAt
      displayName
      email
      id
      organizationProfileId
      owner
      profilePictureUrl
      showBio
      showDisplayName
      showEmail
      showProfilePicture
      updatedAt
      __typename
    }
  }
`;
export const deleteSolarEnergyModel = /* GraphQL */ `
  mutation DeleteSolarEnergyModel(
    $condition: ModelSolarEnergyModelConditionInput
    $input: DeleteSolarEnergyModelInput!
  ) {
    deleteSolarEnergyModel(condition: $condition, input: $input) {
      acCap
      arrayAzimuth
      arrayTilt
      createdAt
      dcCap
      description
      groundCoverRatio
      id
      maxTilt
      minIrradiance
      name
      owner
      panelEfficiency
      thermalLoss
      trackingType
      updatedAt
      xUnit
      yUnit
      __typename
    }
  }
`;
export const deleteSystemPrompt = /* GraphQL */ `
  mutation DeleteSystemPrompt(
    $condition: ModelSystemPromptConditionInput
    $input: DeleteSystemPromptInput!
  ) {
    deleteSystemPrompt(condition: $condition, input: $input) {
      createdAt
      description
      id
      isDefault
      model
      promptText
      rating
      surface
      updatedAt
      __typename
    }
  }
`;
export const deleteUploadData = /* GraphQL */ `
  mutation DeleteUploadData(
    $condition: ModelUploadDataConditionInput
    $input: DeleteUploadDataInput!
  ) {
    deleteUploadData(condition: $condition, input: $input) {
      createdAt
      description
      fileLocation
      id
      name
      objective
      optimizationHorizon
      owner
      parameter
      seasonality
      temporalResolution
      updatedAt
      __typename
    }
  }
`;
export const deleteUser = /* GraphQL */ `
  mutation DeleteUser(
    $condition: ModelUserConditionInput
    $input: DeleteUserInput!
  ) {
    deleteUser(condition: $condition, input: $input) {
      assetCount
      assetGroupCount
      assetGroups {
        nextToken
        __typename
      }
      chatPrivacyPolicyAccepted
      chatPrivacyPolicyLocation
      cognitoIdentityId
      createdAt
      email
      geoPoints {
        nextToken
        __typename
      }
      id
      name
      organizationIds
      organizations {
        nextToken
        __typename
      }
      personas {
        nextToken
        __typename
      }
      preferredPersona {
        completed
        createdAt
        description
        id
        markets
        name
        owner
        regions
        selectedNeeds
        summary
        updatedAt
        userId
        __typename
      }
      preferredPersonaId
      privacyPolicyAuditTrail
      profilePictureUrl
      termsAndConditionsAuditTrail
      termsAndConditionsLocation
      termsAndConditionsReviewed
      tourAssetSeen
      tourChatCompleted
      tourGroupSeen
      tourOnboardingGuidanceSent
      tourWelcomeShown
      updatedAt
      userConsent
      username
      __typename
    }
  }
`;
export const deleteUserChecklistProgress = /* GraphQL */ `
  mutation DeleteUserChecklistProgress(
    $condition: ModelUserChecklistProgressConditionInput
    $input: DeleteUserChecklistProgressInput!
  ) {
    deleteUserChecklistProgress(condition: $condition, input: $input) {
      createdAt
      hatUnlocked
      id
      loginDates
      owner
      shippingAddress
      step1Complete
      step2Complete
      step3Complete
      step4Complete
      step5Complete
      step6Complete
      updatedAt
      userId
      welcomeShown
      __typename
    }
  }
`;
export const deleteUserOrganizations = /* GraphQL */ `
  mutation DeleteUserOrganizations(
    $condition: ModelUserOrganizationsConditionInput
    $input: DeleteUserOrganizationsInput!
  ) {
    deleteUserOrganizations(condition: $condition, input: $input) {
      createdAt
      id
      organization {
        createdAt
        description
        id
        name
        orgAiAnalystAccess
        owner
        profilePictureUrl
        updatedAt
        __typename
      }
      organizationId
      owner
      updatedAt
      user {
        assetCount
        assetGroupCount
        chatPrivacyPolicyAccepted
        chatPrivacyPolicyLocation
        cognitoIdentityId
        createdAt
        email
        id
        name
        organizationIds
        preferredPersonaId
        privacyPolicyAuditTrail
        profilePictureUrl
        termsAndConditionsAuditTrail
        termsAndConditionsLocation
        termsAndConditionsReviewed
        tourAssetSeen
        tourChatCompleted
        tourGroupSeen
        tourOnboardingGuidanceSent
        tourWelcomeShown
        updatedAt
        userConsent
        username
        __typename
      }
      userID
      __typename
    }
  }
`;
export const deleteUserPersona = /* GraphQL */ `
  mutation DeleteUserPersona(
    $condition: ModelUserPersonaConditionInput
    $input: DeleteUserPersonaInput!
  ) {
    deleteUserPersona(condition: $condition, input: $input) {
      completed
      createdAt
      description
      id
      markets
      name
      owner
      regions
      selectedNeeds
      summary
      updatedAt
      user {
        assetCount
        assetGroupCount
        chatPrivacyPolicyAccepted
        chatPrivacyPolicyLocation
        cognitoIdentityId
        createdAt
        email
        id
        name
        organizationIds
        preferredPersonaId
        privacyPolicyAuditTrail
        profilePictureUrl
        termsAndConditionsAuditTrail
        termsAndConditionsLocation
        termsAndConditionsReviewed
        tourAssetSeen
        tourChatCompleted
        tourGroupSeen
        tourOnboardingGuidanceSent
        tourWelcomeShown
        updatedAt
        userConsent
        username
        __typename
      }
      userId
      __typename
    }
  }
`;
export const deleteUserProject = /* GraphQL */ `
  mutation DeleteUserProject(
    $condition: ModelUserProjectConditionInput
    $input: DeleteUserProjectInput!
  ) {
    deleteUserProject(condition: $condition, input: $input) {
      createdAt
      datasetIds
      description
      id
      imageUrl
      organizationId
      owner
      tasks {
        nextToken
        __typename
      }
      title
      updatedAt
      __typename
    }
  }
`;
export const deleteUserProjectTask = /* GraphQL */ `
  mutation DeleteUserProjectTask(
    $condition: ModelUserProjectTaskConditionInput
    $input: DeleteUserProjectTaskInput!
  ) {
    deleteUserProjectTask(condition: $condition, input: $input) {
      completedTask
      createdAt
      description
      id
      order
      owner
      project {
        createdAt
        datasetIds
        description
        id
        imageUrl
        organizationId
        owner
        title
        updatedAt
        __typename
      }
      projectId
      title
      updatedAt
      __typename
    }
  }
`;
export const deleteUserSubscription = /* GraphQL */ `
  mutation DeleteUserSubscription(
    $condition: ModelUserSubscriptionConditionInput
    $input: DeleteUserSubscriptionInput!
  ) {
    deleteUserSubscription(condition: $condition, input: $input) {
      cancelAt
      cancelAtPeriodEnd
      createdAt
      currentPeriodEnd
      customerId
      entitlements
      id
      items
      lastPaymentDate
      lastPaymentStatus
      livemode
      owner
      status
      updatedAt
      __typename
    }
  }
`;
export const deleteUserTokenGrant = /* GraphQL */ `
  mutation DeleteUserTokenGrant(
    $condition: ModelUserTokenGrantConditionInput
    $input: DeleteUserTokenGrantInput!
  ) {
    deleteUserTokenGrant(condition: $condition, input: $input) {
      active
      createdAt
      email
      expiresAt
      grantedBy
      id
      notes
      tokenLimit
      updatedAt
      __typename
    }
  }
`;
export const updateAccessRequest = /* GraphQL */ `
  mutation UpdateAccessRequest(
    $condition: ModelAccessRequestConditionInput
    $input: UpdateAccessRequestInput!
  ) {
    updateAccessRequest(condition: $condition, input: $input) {
      adminNotes
      createdAt
      description
      email
      id
      owner
      status
      updatedAt
      __typename
    }
  }
`;
export const updateAgentSchedule = /* GraphQL */ `
  mutation UpdateAgentSchedule(
    $condition: ModelAgentScheduleConditionInput
    $input: UpdateAgentScheduleInput!
  ) {
    updateAgentSchedule(condition: $condition, input: $input) {
      createdAt
      cronExpression
      description
      error
      id
      lastRunAt
      metadata
      nextRunAt
      organizationId
      owner
      projectId
      runCount
      runners {
        nextToken
        __typename
      }
      runs {
        nextToken
        __typename
      }
      runtime
      status
      systemPrompt
      timezone
      title
      updatedAt
      __typename
    }
  }
`;
export const updateAgentScheduleRun = /* GraphQL */ `
  mutation UpdateAgentScheduleRun(
    $condition: ModelAgentScheduleRunConditionInput
    $input: UpdateAgentScheduleRunInput!
  ) {
    updateAgentScheduleRun(condition: $condition, input: $input) {
      conversations {
        nextToken
        __typename
      }
      createdAt
      error
      id
      organizationId
      owner
      schedule {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      scheduleId
      status
      updatedAt
      __typename
    }
  }
`;
export const updateAgentScheduleRunner = /* GraphQL */ `
  mutation UpdateAgentScheduleRunner(
    $condition: ModelAgentScheduleRunnerConditionInput
    $input: UpdateAgentScheduleRunnerInput!
  ) {
    updateAgentScheduleRunner(condition: $condition, input: $input) {
      attachments
      conversations {
        nextToken
        __typename
      }
      createdAt
      emailCondition
      emailConditionMode
      id
      organizationId
      owner
      prompt
      schedule {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      scheduleId
      sendEmail
      sortOrder
      title
      updatedAt
      __typename
    }
  }
`;
export const updateApiIdempotencyKey = /* GraphQL */ `
  mutation UpdateApiIdempotencyKey(
    $condition: ModelApiIdempotencyKeyConditionInput
    $input: UpdateApiIdempotencyKeyInput!
  ) {
    updateApiIdempotencyKey(condition: $condition, input: $input) {
      claimToken
      createdAt
      expiresAt
      id
      owner
      requestHash
      response
      responseStatus
      route
      status
      updatedAt
      __typename
    }
  }
`;
export const updateAssetGroup = /* GraphQL */ `
  mutation UpdateAssetGroup(
    $condition: ModelAssetGroupConditionInput
    $input: UpdateAssetGroupInput!
  ) {
    updateAssetGroup(condition: $condition, input: $input) {
      assets {
        nextToken
        __typename
      }
      createdAt
      description
      displayedChannels
      id
      linkedProcessedModelSchemas {
        nextToken
        __typename
      }
      name
      organizationId
      owner
      profilePictureUrl
      updatedAt
      userAssetGroupsId
      __typename
    }
  }
`;
export const updateComposedForecast = /* GraphQL */ `
  mutation UpdateComposedForecast(
    $condition: ModelComposedForecastConditionInput
    $input: UpdateComposedForecastInput!
  ) {
    updateComposedForecast(condition: $condition, input: $input) {
      aggregationMethod
      createdAt
      dataSources {
        nextToken
        __typename
      }
      description
      forecastHorizon
      forecastType
      id
      isActive
      lastProcessed
      linkedAssets {
        nextToken
        __typename
      }
      name
      organizationId
      outputParameters
      owner
      processingSchedule
      updateFrequency
      updatedAt
      validationThresholds
      __typename
    }
  }
`;
export const updateComposedForecastAssets = /* GraphQL */ `
  mutation UpdateComposedForecastAssets(
    $condition: ModelComposedForecastAssetsConditionInput
    $input: UpdateComposedForecastAssetsInput!
  ) {
    updateComposedForecastAssets(condition: $condition, input: $input) {
      asset {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      assetID
      composedForecast {
        aggregationMethod
        createdAt
        description
        forecastHorizon
        forecastType
        id
        isActive
        lastProcessed
        name
        organizationId
        outputParameters
        owner
        processingSchedule
        updateFrequency
        updatedAt
        validationThresholds
        __typename
      }
      composedForecastID
      createdAt
      icon
      id
      isDefault
      organizationId
      owner
      updatedAt
      __typename
    }
  }
`;
export const updateComposedForecastDataSource = /* GraphQL */ `
  mutation UpdateComposedForecastDataSource(
    $condition: ModelComposedForecastDataSourceConditionInput
    $input: UpdateComposedForecastDataSourceInput!
  ) {
    updateComposedForecastDataSource(condition: $condition, input: $input) {
      composedForecast {
        aggregationMethod
        createdAt
        description
        forecastHorizon
        forecastType
        id
        isActive
        lastProcessed
        name
        organizationId
        outputParameters
        owner
        processingSchedule
        updateFrequency
        updatedAt
        validationThresholds
        __typename
      }
      composedForecastId
      createdAt
      dataOperations
      dataQualityScore
      externalApiEndpoint
      externalApiHeaders
      externalApiKey
      externalApiParams
      fallbackStrategy
      fallbackValue
      fetchErrorMessage
      groundTruthSensorId
      groundTruthTableName
      id
      isActive
      lastFetchStatus
      lastFetchedAt
      metadata
      modelOutputTimeOffset
      organizationId
      owner
      postgresAggregation
      postgresColumns
      postgresQuery
      postgresTable
      postgresTimeRange
      priority
      processedModelOutput {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      processedModelOutputId
      projectId
      s3FileFormat
      s3Location
      s3ParseConfig
      sourceDescription
      sourceName
      sourceType
      temporalResolution
      timeAlignment
      timeLag
      transformations
      updatedAt
      validationRules
      weight
      zarrCoordinates
      zarrPath
      zarrTimeSelection
      zarrVariable
      __typename
    }
  }
`;
export const updateDataSetRecord = /* GraphQL */ `
  mutation UpdateDataSetRecord(
    $condition: ModelDataSetRecordConditionInput
    $input: UpdateDataSetRecordInput!
  ) {
    updateDataSetRecord(condition: $condition, input: $input) {
      columns
      compressedSize
      compressionType
      createdAt
      dataset {
        columns
        createdAt
        curationMode
        datasetType
        deletedAt
        description
        duplicatePolicy
        fileFormat
        fileSize
        id
        ingestMetadata
        lastUpdated
        linkedAssets
        linkedSchemas
        location
        locationId
        name
        organizationId
        owner
        parameterType
        profilePictureUrl
        recordCount
        routeLong
        slug
        sourceModelId
        tags
        timeRange
        units
        updateFrequency
        updatedAt
        userId
        __typename
      }
      datasetId
      fileName
      fileSize
      id
      organizationId
      owner
      recordCount
      s3Path
      timeRange
      timeValue
      updatedAt
      uploadId
      uploadedAt
      uploadedBy
      uploadedByEmail
      __typename
    }
  }
`;
export const updateDataSource = /* GraphQL */ `
  mutation UpdateDataSource(
    $condition: ModelDataSourceConditionInput
    $input: UpdateDataSourceInput!
  ) {
    updateDataSource(condition: $condition, input: $input) {
      createdAt
      dataOperations
      databaseTable
      format
      id
      isGroundTruth
      metadata
      name
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaId
      s3Path
      sourceType
      updatedAt
      __typename
    }
  }
`;
export const updateDataset = /* GraphQL */ `
  mutation UpdateDataset(
    $condition: ModelDatasetConditionInput
    $input: UpdateDatasetInput!
  ) {
    updateDataset(condition: $condition, input: $input) {
      columns
      createdAt
      curationMode
      datasetType
      deletedAt
      description
      duplicatePolicy
      fileFormat
      fileSize
      id
      ingestMetadata
      lastUpdated
      linkedAssets
      linkedSchemas
      location
      locationId
      name
      organizationId
      owner
      parameterType
      profilePictureUrl
      recordCount
      records {
        nextToken
        __typename
      }
      routeLong
      slug
      sourceModelId
      tags
      timeRange
      units
      updateFrequency
      updatedAt
      userId
      __typename
    }
  }
`;
export const updateDatasetUpload = /* GraphQL */ `
  mutation UpdateDatasetUpload(
    $condition: ModelDatasetUploadConditionInput
    $input: UpdateDatasetUploadInput!
  ) {
    updateDatasetUpload(condition: $condition, input: $input) {
      columnMetadata
      columnSources
      columns
      createdAt
      datasetId
      duplicateTimestamps
      failureReason
      fileName
      id
      incomingKey
      inputsReadAt
      organizationId
      outputParamId
      owner
      processedAt
      processedModelSchemaId
      rawKey
      receivedAt
      recordId
      rejectedKey
      requestedAt
      rowCount
      runId
      sizeBytes
      source
      sourceTimezone
      status
      timeRange
      updatedAt
      uploadedBy
      uploadedByEmail
      validationErrors
      warnings
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const updateErrorLog = /* GraphQL */ `
  mutation UpdateErrorLog(
    $condition: ModelErrorLogConditionInput
    $input: UpdateErrorLogInput!
  ) {
    updateErrorLog(condition: $condition, input: $input) {
      adminNotes
      cognitoIdentityId
      createdAt
      description
      id
      images
      mcpConversationId
      mcpMessageId
      owner
      pageUrl
      source
      status
      updatedAt
      userEmail
      __typename
    }
  }
`;
export const updateForecastRecord = /* GraphQL */ `
  mutation UpdateForecastRecord(
    $condition: ModelForecastRecordConditionInput
    $input: UpdateForecastRecordInput!
  ) {
    updateForecastRecord(condition: $condition, input: $input) {
      createdAt
      forecastIssued
      id
      inputs
      metadata
      organizationId
      owner
      parameter {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      parameterId
      run {
        acknowledged
        acknowledgedAt
        acknowledgedBy
        attempt
        completedAt
        createdAt
        description
        executionTimeMs
        id
        inputs
        modelSchemaTemplateId
        organizationId
        outputS3Keys
        owner
        processedModelScheduleId
        processedModelSchemaId
        requestId
        startedAt
        status
        triggerType
        updatedAt
        windowEnd
        windowStart
        __typename
      }
      runId
      s3Key
      seriesEnd
      seriesMetaData
      seriesStart
      source
      updatedAt
      uploadId
      uploadedBy
      __typename
    }
  }
`;
export const updateForecastReport = /* GraphQL */ `
  mutation UpdateForecastReport(
    $condition: ModelForecastReportConditionInput
    $input: UpdateForecastReportInput!
  ) {
    updateForecastReport(condition: $condition, input: $input) {
      completedAt
      config
      createdAt
      description
      error
      id
      identityId
      name
      organizationId
      owner
      progress
      resultS3Key
      startedAt
      status
      summary
      updatedAt
      __typename
    }
  }
`;
export const updateForecastUpload = /* GraphQL */ `
  mutation UpdateForecastUpload(
    $condition: ModelForecastUploadConditionInput
    $input: UpdateForecastUploadInput!
  ) {
    updateForecastUpload(condition: $condition, input: $input) {
      createdAt
      failureReason
      fileName
      finalKey
      forecastIssued
      forecastRecordId
      id
      incomingKey
      issueTime
      organizationId
      outputParamId
      owner
      parameters
      processedAt
      rawKey
      receivedAt
      requestedAt
      rowCount
      schemaId
      sizeBytes
      source
      status
      timeRange
      updatedAt
      uploadedBy
      uploadedByEmail
      validationErrors
      warnings
      __typename
    }
  }
`;
export const updateGeoPoint = /* GraphQL */ `
  mutation UpdateGeoPoint(
    $condition: ModelGeoPointConditionInput
    $input: UpdateGeoPointInput!
  ) {
    updateGeoPoint(condition: $condition, input: $input) {
      assetGroupId
      client
      createdAt
      description
      displayedChannels
      elevation
      geojson
      icon
      id
      imageUrl
      lat
      linkedComposedForecasts {
        nextToken
        __typename
      }
      linkedProcessedModelSchemas {
        nextToken
        __typename
      }
      lng
      name
      organizationId
      owner
      precipCurve {
        createdAt
        description
        id
        name
        organizationId
        organizationIds
        owner
        updatedAt
        xUnit
        yUnit
        __typename
      }
      precipCurveId
      processedModels {
        nextToken
        __typename
      }
      solarCurve {
        acCap
        arrayAzimuth
        arrayTilt
        createdAt
        dcCap
        description
        groundCoverRatio
        id
        maxTilt
        minIrradiance
        name
        owner
        panelEfficiency
        thermalLoss
        trackingType
        updatedAt
        xUnit
        yUnit
        __typename
      }
      solarCurveId
      tags
      updatedAt
      userGeoPointsId
      value {
        currency
        value
        __typename
      }
      windCurve {
        createdAt
        description
        id
        name
        organizationId
        organizationIds
        owner
        updatedAt
        xUnit
        yUnit
        __typename
      }
      windCurveId
      __typename
    }
  }
`;
export const updateLlmResponse = /* GraphQL */ `
  mutation UpdateLlmResponse(
    $condition: ModelLlmResponseConditionInput
    $input: UpdateLlmResponseInput!
  ) {
    updateLlmResponse(condition: $condition, input: $input) {
      conversation
      createdAt
      description
      executionTime
      id
      owner
      queryType
      response
      updatedAt
      uploadURL
      __typename
    }
  }
`;
export const updateLoginAccessCodes = /* GraphQL */ `
  mutation UpdateLoginAccessCodes(
    $condition: ModelLoginAccessCodesConditionInput
    $input: UpdateLoginAccessCodesInput!
  ) {
    updateLoginAccessCodes(condition: $condition, input: $input) {
      activatedBy
      available
      code
      createdAt
      notes
      recipient
      updatedAt
      __typename
    }
  }
`;
export const updateMCPConversation = /* GraphQL */ `
  mutation UpdateMCPConversation(
    $condition: ModelMCPConversationConditionInput
    $input: UpdateMCPConversationInput!
  ) {
    updateMCPConversation(condition: $condition, input: $input) {
      agentScheduleRunId
      agentScheduleRunnerId
      conversationType
      createdAt
      id
      isActive
      lastMessageAt
      messageCount
      messages {
        nextToken
        __typename
      }
      metadata
      model
      modelCodename
      organizationId
      owner
      projectId
      projectTaskId
      title
      totalTokens
      unreadCount
      updatedAt
      __typename
    }
  }
`;
export const updateMCPMessage = /* GraphQL */ `
  mutation UpdateMCPMessage(
    $condition: ModelMCPMessageConditionInput
    $input: UpdateMCPMessageInput!
  ) {
    updateMCPMessage(condition: $condition, input: $input) {
      attachments
      content
      conversation {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      conversationId
      createdAt
      enhancedPrompt
      executionTimeMs
      id
      inputTokens
      isUser
      messageRead
      model
      modelCodename
      organizationId
      outputTokens
      owner
      rating
      ratingComment
      rounds
      serverId
      sessionId
      status
      toolsCount
      updatedAt
      __typename
    }
  }
`;
export const updateMCPSharedConversation = /* GraphQL */ `
  mutation UpdateMCPSharedConversation(
    $condition: ModelMCPSharedConversationConditionInput
    $input: UpdateMCPSharedConversationInput!
  ) {
    updateMCPSharedConversation(condition: $condition, input: $input) {
      conversationId
      conversationType
      createdAt
      id
      includePrompts
      isActive
      messageId
      organizationId
      owner
      s3Key
      scheduleRunnerId
      scope
      title
      updatedAt
      __typename
    }
  }
`;
export const updateMCPUsage = /* GraphQL */ `
  mutation UpdateMCPUsage(
    $condition: ModelMCPUsageConditionInput
    $input: UpdateMCPUsageInput!
  ) {
    updateMCPUsage(condition: $condition, input: $input) {
      createdAt
      id
      period
      requestCount
      subscriptionTier
      tokenLimit
      tokensUsed
      updatedAt
      userId
      __typename
    }
  }
`;
export const updateModelSchemaTemplate = /* GraphQL */ `
  mutation UpdateModelSchemaTemplate(
    $condition: ModelModelSchemaTemplateConditionInput
    $input: UpdateModelSchemaTemplateInput!
  ) {
    updateModelSchemaTemplate(condition: $condition, input: $input) {
      authorProfileId
      authorType
      category
      createdAt
      createdBy
      description
      executionUrl
      external
      fieldDefinitions
      historicalConfig
      id
      isActive
      modelKind
      name
      profilePictureUrl
      requiresTraining
      tags
      trainingCost
      updatedAt
      version
      __typename
    }
  }
`;
export const updateOrganization = /* GraphQL */ `
  mutation UpdateOrganization(
    $condition: ModelOrganizationConditionInput
    $input: UpdateOrganizationInput!
  ) {
    updateOrganization(condition: $condition, input: $input) {
      createdAt
      description
      id
      members {
        nextToken
        __typename
      }
      name
      orgAiAnalystAccess
      owner
      profilePictureUrl
      updatedAt
      __typename
    }
  }
`;
export const updateOrganizationPublicProfile = /* GraphQL */ `
  mutation UpdateOrganizationPublicProfile(
    $condition: ModelOrganizationPublicProfileConditionInput
    $input: UpdateOrganizationPublicProfileInput!
  ) {
    updateOrganizationPublicProfile(condition: $condition, input: $input) {
      bio
      createdAt
      displayName
      email
      employees {
        nextToken
        __typename
      }
      id
      owner
      profilePictureUrl
      showBio
      showDisplayName
      showEmail
      showProfilePicture
      updatedAt
      __typename
    }
  }
`;
export const updatePerformanceCurve = /* GraphQL */ `
  mutation UpdatePerformanceCurve(
    $condition: ModelPerformanceCurveConditionInput
    $input: UpdatePerformanceCurveInput!
  ) {
    updatePerformanceCurve(condition: $condition, input: $input) {
      createdAt
      curveData {
        x
        y
        __typename
      }
      description
      id
      name
      organizationId
      organizationIds
      owner
      updatedAt
      xUnit
      yUnit
      __typename
    }
  }
`;
export const updateProcessedModel = /* GraphQL */ `
  mutation UpdateProcessedModel(
    $condition: ModelProcessedModelConditionInput
    $input: UpdateProcessedModelInput!
  ) {
    updateProcessedModel(condition: $condition, input: $input) {
      additionalDataPoints {
        color
        id
        lookbackDays
        name
        parameterId
        schema
        source
        __typename
      }
      assetId
      createdAt
      deliveryCron
      deliveryGraceMinutes
      deliveryMatchBy
      deliveryTimezone
      deliveryTrackingStartedAt
      description
      displayType
      geopoint {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      id
      label
      modelType
      organizationId
      owner
      routeLong
      routeShort
      schema
      updatedAt
      __typename
    }
  }
`;
export const updateProcessedModelOutputParam = /* GraphQL */ `
  mutation UpdateProcessedModelOutputParam(
    $condition: ModelProcessedModelOutputParamConditionInput
    $input: UpdateProcessedModelOutputParamInput!
  ) {
    updateProcessedModelOutputParam(condition: $condition, input: $input) {
      active
      channels
      createdAt
      description
      forecasts {
        nextToken
        __typename
      }
      id
      name
      organizationId
      outputLocation
      owner
      parameterTypeId
      schema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      schemaId
      seriesMetaData
      storageMode
      targetDatasetId
      unit
      updatedAt
      __typename
    }
  }
`;
export const updateProcessedModelRunHistory = /* GraphQL */ `
  mutation UpdateProcessedModelRunHistory(
    $condition: ModelProcessedModelRunHistoryConditionInput
    $input: UpdateProcessedModelRunHistoryInput!
  ) {
    updateProcessedModelRunHistory(condition: $condition, input: $input) {
      acknowledged
      acknowledgedAt
      acknowledgedBy
      attempt
      completedAt
      createdAt
      description
      executionTimeMs
      forecasts {
        nextToken
        __typename
      }
      id
      inputs
      modelSchemaTemplateId
      organizationId
      outputS3Keys
      owner
      processedModelScheduleId
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaId
      requestId
      startedAt
      status
      triggerType
      updatedAt
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const updateProcessedModelRunRequest = /* GraphQL */ `
  mutation UpdateProcessedModelRunRequest(
    $condition: ModelProcessedModelRunRequestConditionInput
    $input: UpdateProcessedModelRunRequestInput!
  ) {
    updateProcessedModelRunRequest(condition: $condition, input: $input) {
      attempts
      backfillId
      chunkCount
      chunkIndex
      completedAt
      createdAt
      error
      id
      mergedInto
      notBefore
      organizationId
      owner
      processedModelSchemaId
      runIds
      startedAt
      status
      triggerRef
      triggerType
      updatedAt
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const updateProcessedModelSchedule = /* GraphQL */ `
  mutation UpdateProcessedModelSchedule(
    $condition: ModelProcessedModelScheduleConditionInput
    $input: UpdateProcessedModelScheduleInput!
  ) {
    updateProcessedModelSchedule(condition: $condition, input: $input) {
      createdAt
      cronExpression
      firstRunTime
      frequency
      id
      lastRunAt
      nextRunAt
      organizationId
      owner
      processedModelSchemaId
      runCount
      status
      timezone
      updatedAt
      __typename
    }
  }
`;
export const updateProcessedModelSchema = /* GraphQL */ `
  mutation UpdateProcessedModelSchema(
    $condition: ModelProcessedModelSchemaConditionInput
    $input: UpdateProcessedModelSchemaInput!
  ) {
    updateProcessedModelSchema(condition: $condition, input: $input) {
      activeStatus
      createdAt
      dataSources {
        nextToken
        __typename
      }
      deliveryExpectation
      dependency
      description
      executionUrl
      historicalSettings
      id
      isActive
      linkedAssetGroups {
        nextToken
        __typename
      }
      linkedAssets {
        nextToken
        __typename
      }
      linkedDatasets {
        nextToken
        __typename
      }
      linkedOutputs {
        nextToken
        __typename
      }
      modelKind
      name
      organizationId
      outputs {
        nextToken
        __typename
      }
      owner
      runHistory {
        nextToken
        __typename
      }
      runSchedule
      s3BasePath
      schemaFields
      schemaType
      type
      updatedAt
      version
      __typename
    }
  }
`;
export const updateProcessedModelSchemaAssetGroups = /* GraphQL */ `
  mutation UpdateProcessedModelSchemaAssetGroups(
    $condition: ModelProcessedModelSchemaAssetGroupsConditionInput
    $input: UpdateProcessedModelSchemaAssetGroupsInput!
  ) {
    updateProcessedModelSchemaAssetGroups(
      condition: $condition
      input: $input
    ) {
      assetGroup {
        createdAt
        description
        displayedChannels
        id
        name
        organizationId
        owner
        profilePictureUrl
        updatedAt
        userAssetGroupsId
        __typename
      }
      assetGroupID
      createdAt
      id
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaID
      updatedAt
      __typename
    }
  }
`;
export const updateProcessedModelSchemaAssets = /* GraphQL */ `
  mutation UpdateProcessedModelSchemaAssets(
    $condition: ModelProcessedModelSchemaAssetsConditionInput
    $input: UpdateProcessedModelSchemaAssetsInput!
  ) {
    updateProcessedModelSchemaAssets(condition: $condition, input: $input) {
      asset {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      assetID
      createdAt
      id
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaID
      updatedAt
      __typename
    }
  }
`;
export const updateProcessedModelV1EmailLog = /* GraphQL */ `
  mutation UpdateProcessedModelV1EmailLog(
    $condition: ModelProcessedModelV1EmailLogConditionInput
    $input: UpdateProcessedModelV1EmailLogInput!
  ) {
    updateProcessedModelV1EmailLog(condition: $condition, input: $input) {
      assetCount
      assetNames
      ccRecipientCount
      chartsRendered
      completedAt
      createdAt
      errorMessage
      id
      recipientCount
      scheduleId
      startedAt
      status
      updatedAt
      __typename
    }
  }
`;
export const updateProcessedModelV1EmailSchedule = /* GraphQL */ `
  mutation UpdateProcessedModelV1EmailSchedule(
    $condition: ModelProcessedModelV1EmailScheduleConditionInput
    $input: UpdateProcessedModelV1EmailScheduleInput!
  ) {
    updateProcessedModelV1EmailSchedule(condition: $condition, input: $input) {
      ccRecipients
      createdAt
      cronExpression
      firstRunTime
      frequency
      id
      label
      lastRunAt
      nextRunAt
      organizationId
      owner
      recipients
      runCount
      status
      targets {
        assetId
        assetName
        __typename
      }
      timezone
      updatedAt
      __typename
    }
  }
`;
export const updatePublicProfile = /* GraphQL */ `
  mutation UpdatePublicProfile(
    $condition: ModelPublicProfileConditionInput
    $input: UpdatePublicProfileInput!
  ) {
    updatePublicProfile(condition: $condition, input: $input) {
      bio
      createdAt
      displayName
      email
      id
      organizationProfileId
      owner
      profilePictureUrl
      showBio
      showDisplayName
      showEmail
      showProfilePicture
      updatedAt
      __typename
    }
  }
`;
export const updateSolarEnergyModel = /* GraphQL */ `
  mutation UpdateSolarEnergyModel(
    $condition: ModelSolarEnergyModelConditionInput
    $input: UpdateSolarEnergyModelInput!
  ) {
    updateSolarEnergyModel(condition: $condition, input: $input) {
      acCap
      arrayAzimuth
      arrayTilt
      createdAt
      dcCap
      description
      groundCoverRatio
      id
      maxTilt
      minIrradiance
      name
      owner
      panelEfficiency
      thermalLoss
      trackingType
      updatedAt
      xUnit
      yUnit
      __typename
    }
  }
`;
export const updateSystemPrompt = /* GraphQL */ `
  mutation UpdateSystemPrompt(
    $condition: ModelSystemPromptConditionInput
    $input: UpdateSystemPromptInput!
  ) {
    updateSystemPrompt(condition: $condition, input: $input) {
      createdAt
      description
      id
      isDefault
      model
      promptText
      rating
      surface
      updatedAt
      __typename
    }
  }
`;
export const updateUploadData = /* GraphQL */ `
  mutation UpdateUploadData(
    $condition: ModelUploadDataConditionInput
    $input: UpdateUploadDataInput!
  ) {
    updateUploadData(condition: $condition, input: $input) {
      createdAt
      description
      fileLocation
      id
      name
      objective
      optimizationHorizon
      owner
      parameter
      seasonality
      temporalResolution
      updatedAt
      __typename
    }
  }
`;
export const updateUser = /* GraphQL */ `
  mutation UpdateUser(
    $condition: ModelUserConditionInput
    $input: UpdateUserInput!
  ) {
    updateUser(condition: $condition, input: $input) {
      assetCount
      assetGroupCount
      assetGroups {
        nextToken
        __typename
      }
      chatPrivacyPolicyAccepted
      chatPrivacyPolicyLocation
      cognitoIdentityId
      createdAt
      email
      geoPoints {
        nextToken
        __typename
      }
      id
      name
      organizationIds
      organizations {
        nextToken
        __typename
      }
      personas {
        nextToken
        __typename
      }
      preferredPersona {
        completed
        createdAt
        description
        id
        markets
        name
        owner
        regions
        selectedNeeds
        summary
        updatedAt
        userId
        __typename
      }
      preferredPersonaId
      privacyPolicyAuditTrail
      profilePictureUrl
      termsAndConditionsAuditTrail
      termsAndConditionsLocation
      termsAndConditionsReviewed
      tourAssetSeen
      tourChatCompleted
      tourGroupSeen
      tourOnboardingGuidanceSent
      tourWelcomeShown
      updatedAt
      userConsent
      username
      __typename
    }
  }
`;
export const updateUserChecklistProgress = /* GraphQL */ `
  mutation UpdateUserChecklistProgress(
    $condition: ModelUserChecklistProgressConditionInput
    $input: UpdateUserChecklistProgressInput!
  ) {
    updateUserChecklistProgress(condition: $condition, input: $input) {
      createdAt
      hatUnlocked
      id
      loginDates
      owner
      shippingAddress
      step1Complete
      step2Complete
      step3Complete
      step4Complete
      step5Complete
      step6Complete
      updatedAt
      userId
      welcomeShown
      __typename
    }
  }
`;
export const updateUserOrganizations = /* GraphQL */ `
  mutation UpdateUserOrganizations(
    $condition: ModelUserOrganizationsConditionInput
    $input: UpdateUserOrganizationsInput!
  ) {
    updateUserOrganizations(condition: $condition, input: $input) {
      createdAt
      id
      organization {
        createdAt
        description
        id
        name
        orgAiAnalystAccess
        owner
        profilePictureUrl
        updatedAt
        __typename
      }
      organizationId
      owner
      updatedAt
      user {
        assetCount
        assetGroupCount
        chatPrivacyPolicyAccepted
        chatPrivacyPolicyLocation
        cognitoIdentityId
        createdAt
        email
        id
        name
        organizationIds
        preferredPersonaId
        privacyPolicyAuditTrail
        profilePictureUrl
        termsAndConditionsAuditTrail
        termsAndConditionsLocation
        termsAndConditionsReviewed
        tourAssetSeen
        tourChatCompleted
        tourGroupSeen
        tourOnboardingGuidanceSent
        tourWelcomeShown
        updatedAt
        userConsent
        username
        __typename
      }
      userID
      __typename
    }
  }
`;
export const updateUserPersona = /* GraphQL */ `
  mutation UpdateUserPersona(
    $condition: ModelUserPersonaConditionInput
    $input: UpdateUserPersonaInput!
  ) {
    updateUserPersona(condition: $condition, input: $input) {
      completed
      createdAt
      description
      id
      markets
      name
      owner
      regions
      selectedNeeds
      summary
      updatedAt
      user {
        assetCount
        assetGroupCount
        chatPrivacyPolicyAccepted
        chatPrivacyPolicyLocation
        cognitoIdentityId
        createdAt
        email
        id
        name
        organizationIds
        preferredPersonaId
        privacyPolicyAuditTrail
        profilePictureUrl
        termsAndConditionsAuditTrail
        termsAndConditionsLocation
        termsAndConditionsReviewed
        tourAssetSeen
        tourChatCompleted
        tourGroupSeen
        tourOnboardingGuidanceSent
        tourWelcomeShown
        updatedAt
        userConsent
        username
        __typename
      }
      userId
      __typename
    }
  }
`;
export const updateUserProject = /* GraphQL */ `
  mutation UpdateUserProject(
    $condition: ModelUserProjectConditionInput
    $input: UpdateUserProjectInput!
  ) {
    updateUserProject(condition: $condition, input: $input) {
      createdAt
      datasetIds
      description
      id
      imageUrl
      organizationId
      owner
      tasks {
        nextToken
        __typename
      }
      title
      updatedAt
      __typename
    }
  }
`;
export const updateUserProjectTask = /* GraphQL */ `
  mutation UpdateUserProjectTask(
    $condition: ModelUserProjectTaskConditionInput
    $input: UpdateUserProjectTaskInput!
  ) {
    updateUserProjectTask(condition: $condition, input: $input) {
      completedTask
      createdAt
      description
      id
      order
      owner
      project {
        createdAt
        datasetIds
        description
        id
        imageUrl
        organizationId
        owner
        title
        updatedAt
        __typename
      }
      projectId
      title
      updatedAt
      __typename
    }
  }
`;
export const updateUserSubscription = /* GraphQL */ `
  mutation UpdateUserSubscription(
    $condition: ModelUserSubscriptionConditionInput
    $input: UpdateUserSubscriptionInput!
  ) {
    updateUserSubscription(condition: $condition, input: $input) {
      cancelAt
      cancelAtPeriodEnd
      createdAt
      currentPeriodEnd
      customerId
      entitlements
      id
      items
      lastPaymentDate
      lastPaymentStatus
      livemode
      owner
      status
      updatedAt
      __typename
    }
  }
`;
export const updateUserTokenGrant = /* GraphQL */ `
  mutation UpdateUserTokenGrant(
    $condition: ModelUserTokenGrantConditionInput
    $input: UpdateUserTokenGrantInput!
  ) {
    updateUserTokenGrant(condition: $condition, input: $input) {
      active
      createdAt
      email
      expiresAt
      grantedBy
      id
      notes
      tokenLimit
      updatedAt
      __typename
    }
  }
`;
